<template>
  <section class="sign-up">
    <div class="sign-up__link">
      <router-link to="/login">{{ $t('myPage.auth.haveAccount') }}</router-link>
    </div>
    <PersonalInfoForm
      idPrefix="signUp"
      @update:user="updateUser"
      />
    <button
      type="button"
      class="button button--medium button--primary"
      @click="submitForm"
    >
      {{ $t('myPage.auth.submit') }}
    </button>
    <p v-if="errorMessage" class="sign-up__error">{{ errorMessage }}</p>
  </section>
</template>

<script>
  import { defineComponent, ref } from 'vue'
  import { useRouter } from 'vue-router'
  import { useI18n } from 'vue-i18n'
  import { useBookingStore } from '@/stores/bookingStore'
  import { useUserStore } from '@/stores/userStore'
  import { useMyTravelStore } from '@/stores/myTravelStore'
  import PersonalInfoForm from '@/components/BaseComponents/PersonalInfoForm.vue'
  import { createUser } from '@/services/userService'

  export default defineComponent({
    name: 'SignUp',
    components: {
      PersonalInfoForm,
    },
    emits: ['sign-up-success'],
    setup(_, { emit }) {
      const user = ref({
        first_name: '',
        last_name: '',
        email: '',
        phone_numbers: [],
      })
      const { t } = useI18n()
      const errorMessage = ref('')
      const router = useRouter()
      const bookingStore = useBookingStore()
      const userStore = useUserStore()
      const myTravelStore = useMyTravelStore()

      const updateUser = (userInfo) => {
        user.value = userInfo
      }

      const submitForm = async () => {
        try {
          // Store booking information before creating user
          const currentBookingNumber = bookingStore.bookingNumber
          const currentBookingToken = localStorage.getItem('token')
          
          if (currentBookingNumber) {
            localStorage.setItem('pendingBooking', 'true')
            localStorage.setItem('pendingBookingNumber', currentBookingNumber)
            if (currentBookingToken) {
              // No need to duplicate token storage
            }
            
            // Save MyTravel state to localStorage
            myTravelStore.saveStateToLocalStorage()
          }

          // Store user info in userStore for autofill
          userStore.setUser({
            ...user.value,
            id: '', // Will be set after successful signup
            type: 'user'
          })

          const response = await createUser(user.value)
          emit('sign-up-success')
        } catch (error) {
          console.error('Sign up error:', error)
          errorMessage.value = error.response?.status === 409
            ? t('myPage.auth.signup.error.emailExists')
            : t('myPage.auth.signup.error.general')
        }
      }

      return {
        updateUser,
        submitForm,
        errorMessage,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .sign-up {
    &__link {
      text-align: left;
      margin-bottom: 1.875rem;
      @include body-large;
    }

    h2 {
      @include headline-medium;
      text-align: left;
    }

    button {
      margin-top: 1rem;
      width: 100%;
    }
  }
</style>
